import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[appWidth]',
    standalone: false
})
export class WidthDirective {

  @Input('appWidth') width: number;

  constructor(private el: ElementRef) { }

  ngOnChanges() {
    this.el.nativeElement.style.width = this.width + "px";
  }
}
